import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ConfirmationModal from '../components/ConfirmationModal';

const ConfirmationContext = createContext();

export const useConfirmation = () => {
    const context = useContext(ConfirmationContext);
    if (!context) {
        throw new Error('useConfirmation must be used within a ConfirmationProvider');
    }
    return context;
};

export const ConfirmationProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        isOpen: false,
        title: '',
        message: '',
        confirmLabel: 'Confirm',
        cancelLabel: 'Cancel',
        type: 'danger'
    });

    const resolver = useRef(null);

    const confirm = useCallback(({
        title = 'Confirm Action',
        message = 'Are you sure?',
        confirmLabel = 'Confirm',
        cancelLabel = 'Cancel',
        type = 'danger'
    }) => {
        setModalState({
            isOpen: true,
            title,
            message,
            confirmLabel,
            cancelLabel,
            type
        });

        return new Promise((resolve) => {
            resolver.current = resolve;
        });
    }, []);

    const handleConfirm = () => {
        setModalState(prev => ({ ...prev, isOpen: false }));
        if (resolver.current) {
            resolver.current(true);
            resolver.current = null;
        }
    };

    const handleCancel = () => {
        setModalState(prev => ({ ...prev, isOpen: false }));
        if (resolver.current) {
            resolver.current(false);
            resolver.current = null;
        }
    };

    return (
        <ConfirmationContext.Provider value={confirm}>
            {children}
            <ConfirmationModal
                {...modalState}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </ConfirmationContext.Provider>
    );
};
